export const semanticTokens = {
  colors: {
    scrollThumb: {
      _light: "rgba(0, 0, 0, 0.2)",
      _dark: "rgba(255, 255, 255, 0.4)"
    }
  },
  shadows: {
    elevation1: {
      _light:
        "0px 1px 2px rgba(0, 0, 0, 0.3), 0px 1px 3px 1px rgba(0, 0, 0, 0.15)",
      _dark:
        "0px 1px 3px 1px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.3)"
    },
    elevation2: {
      _light:
        "0px 1px 2px rgba(0, 0, 0, 0.3), 0px 2px 6px 2px rgba(0, 0, 0, 0.15)",
      _dark:
        "0px 2px 6px 2px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.3)"
    }
  }
};
